import React, { Component } from 'react';
import PSRangeChart from 'ps-components/Charts/PSRangeChart/PSRangeChart';
import PSBarChart from 'ps-components/Charts/PSBarChart/PSBarChart';
import { numberWithCommas } from 'ps-components/lib/formatters';

import { object } from 'prop-types';
import './ChartsViewGrade.scss';

export default class ChartsViewGrade extends Component {
  static propTypes = {
    clickedGrade: object
  };

  noChartCondition(dat) {
    if (dat[0] === dat[1] && dat[1] === dat[2]) {
      return false;
    }
    return true;
  }

  render() {
    const { clickedGrade } = this.props;
    const barDat2 = [clickedGrade.proposed.min, clickedGrade.proposed.mid, clickedGrade.proposed.max];
    const barDat1 = !clickedGrade.current.min
      ? barDat2
      : [clickedGrade.current.min, clickedGrade.current.mid, clickedGrade.current.max];
    let scaleMax = Math.max(...barDat1, ...barDat2);
    let scaleMin = Math.min(...barDat1, ...barDat2);
    if (clickedGrade.avg && clickedGrade.proposed && clickedGrade.proposed.mid >= 0) {
      const scaleAvg = (scaleMin + scaleMax) / 2;
      const diff = clickedGrade.avg - scaleAvg;
      if (diff > 0) scaleMax = 2 * clickedGrade.avg - scaleMin;
      else scaleMin = 2 * clickedGrade.avg - scaleMax;
    }
    const maxBarHeight = Math.max(
      clickedGrade.totals.costToMin.current ? clickedGrade.totals.costToMin.current : 0,
      clickedGrade.totals.costToMin.proposed
    );
    return (
      <div className="details-charts-container">
        <div className="chart-box">
          <span className="name">Range Spread</span>
          <div className="chart-container">
            {clickedGrade.avg && (
              <React.Fragment>
                <div className="chart-list-header">
                  {'Mkt Base 50th (' + numberWithCommas(clickedGrade.avg.toFixed(0)) + ')'}
                </div>
                <div className="market-average-line" />
              </React.Fragment>
            )}
            <div className={'chart-pair'}>
              {this.noChartCondition(barDat1) && !!clickedGrade.current.min && (
                <PSRangeChart
                  rangeValues={barDat1}
                  scaleMin={scaleMin}
                  scaleMax={scaleMax}
                  roundTo={1}
                  payType="annual"
                  id="sma-chart-range-1"
                />
              )}
              {this.noChartCondition(barDat2) && (
                <PSRangeChart
                  rangeValues={barDat2}
                  scaleMin={scaleMin}
                  scaleMax={scaleMax}
                  roundTo={1}
                  payType="annual"
                  id="sma-chart-range-2"
                  colors={['#22D6DD', '#A7EFF1']} // pxl.$turquoise, pxl.$turquoise-xlight
                  spaceBottom={true}
                />
              )}
            </div>
          </div>
        </div>
        <div className="chart-box">
          <span className="name">Cost to Bring Employees to Min</span>
          <div className="bar-chart-container">
            <PSBarChart
              label="Current Cost"
              height={parseInt(clickedGrade.totals.costToMin.current)}
              maxHeight={maxBarHeight}
              roundTo={1}
              payType="annual"
            />
            <PSBarChart
              label="Proposed Cost"
              height={parseInt(clickedGrade.totals.costToMin.proposed)}
              maxHeight={maxBarHeight}
              roundTo={1}
              payType="annual"
            />
          </div>
        </div>
      </div>
    );
  }
}
